import { LosseFlexShell } from '@ubo/losse-sjedel'
import type { LosseFlexShellProps, LosseFlexShellType } from '@ubo/losse-sjedel'

// Components
import BannerDefault from './BannerDefault'
import BannerLanding from './BannerLanding'
import BannerDetail from './BannerDetail'
import BannerVideo from './BannerVideo'

export default function BannerShell({ fields, index }: LosseFlexShellProps) {
  const types: LosseFlexShellType = {
    default: BannerDefault,
    detail: BannerDetail,
    landing: BannerLanding,
    video: BannerVideo
  }

  return <LosseFlexShell types={types} fields={fields} index={index} />
}
